import type { ComposeStore } from './schema/ComposeStore';
import type { ComposeViewState } from './schema/ComposeViewState';
import { createStore } from 'owa-satcheljs';

const composeStoreData: ComposeStore = {
    viewStates: new Map<string, ComposeViewState>(),
    primaryComposeId: null,
    newMessageCreationInProgress: false,
    shouldUseFallbackPeoplePicker: false,
};

export const getStore: () => ComposeStore = createStore<ComposeStore>('compose', composeStoreData);
